module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logo-white-e45b696032576b0ab9ba151b240f3a7f.svg";